import { Typography as MuiTypography, TypographyProps } from '@mui/material';

/**
 *  @deprecated - use Typography from MUI instead
 */
export function Typography<C extends React.ElementType>(
    props: TypographyProps<C, { component?: C }>
) {
    return <MuiTypography {...props} />;
}
